<template>
  <section class="tf-section how-we-work">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="tf-title st2 m-b60" data-aos="fade-up" data-aos-duration="800">
                        <p class="h8 sub-title">How we work</p>
                        <h4 class="title m-b17">BECOME OUR MEMBER</h4>
                        <p class="p-r60">Holders of SonsOfHephaestus, builders themselves, are irreplaceable partners, rooters and co-builders with us at Relsify.  </p>
                    </div>
                   
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-12" data-aos="fade-up" data-aos-delay="100" data-aos-duration="800">
                    <div class="box-text st2 corner-box active">
                        <div class="number">I</div>
                        <div class="h7">Relsify's Marketplace</div>
                        <p>Holders govern the updates, optimizations, and general implementations to be made in our marketplace over time.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-12" data-aos="fade-up" data-aos-delay="200" data-aos-duration="800">
                    <div class="box-text st2 corner-box">
                        <div class="number">II</div>
                        <div class="h7"> Voting Rights</div>
                        <p>Before due diligence on proposed real estate projects are carried out, SonsOfHephaestus determines the favorites based on vote. </p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-12" data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">
                    <div class="box-text st2 corner-box">
                        <div class="number">III</div>
                        <div class="h7">First-know Privilege</div>
                        <p>Every new property listing to be made in our marketplace passes through the ears of SonsOfHephaestus firstly.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-12" data-aos="fade-up" data-aos-delay="400" data-aos-duration="800">
                    <div class="box-text st2 mobie-mb-0 corner-box">
                        <div class="number">IV</div>
                        <div class="h7">$RELS Benefits</div>
                        <p>SonsOfHephaestus will be prioritized when it comes to benefits surrounding the utility token of Relsify's ecosystem. </p>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-12 topmg" data-aos="fade-up" data-aos-delay="100" data-aos-duration="800">
                    <div class="box-text st2 corner-box active">
                        <div class="number">V</div>
                        <div class="h7">Exclusive Offline Events</div>
                        <p>Access and attendance to some of our top-notch offline events would be exclusive to holders of SonsOfHephaestus.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-12 topmg" data-aos="fade-up" data-aos-delay="200" data-aos-duration="800">
                    <div class="box-text st2 corner-box">
                        <div class="number">VI</div>
                        <div class="h7">Secondary Market</div>
                        <p>Participation within our secondary market alongside lower transaction fee are prioritized for SonsOfHephaestus.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-12 topmg" data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">
                    <div class="box-text st2 corner-box">
                        <div class="number">VII</div>
                        <div class="h7">Access to Lemnos</div>
                        <p>An exclusive public facility at Island of Lagos is made available to SonsOfHephaestus for up to 90% discount.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-12 topmg" data-aos="fade-up" data-aos-delay="400" data-aos-duration="800">
                    <div class="box-text st2 mobie-mb-0 corner-box">
                        <div class="number">04</div>
                        <div class="h7">Firm Support</div>
                        <p>Whatever a holder of SonsOfHephaestus is building, when you keep us in the know, count us in for all possible support! </p>
                    </div>
                </div>
                
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'HowWeWorkComponent'
}
</script>

<style>
.topmg {
    margin-top: 20px;
}
</style>